var _rect, _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFreeCoins = function SvgFreeCoins(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 14,
    fill: "#243038"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9167 3H28.5V5.83333H25.6667V7.25H28.5V10.0833H29.9167V7.25H32.75V5.83333H29.9167V3ZM8.66667 35.5833L8.66667 18.5692L3 18.5833L13.2468 5.83333L24.25 18.5833L18.5833 18.5692L18.5833 22.8333L13.625 29.2083L8.66667 35.5833ZM21.4167 37V32.75H15.75L25.6667 20L35.5833 32.7358H29.9167V37H25.699L21.4167 37ZM22.8333 8.66667H24.25V10.0833H25.6667V11.5H24.25V12.9167H22.8333V11.5H21.4167V10.0833H22.8333V8.66667Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9167 3H28.5V5.83333H25.6667V7.25H28.5V10.0833H29.9167V7.25H32.75V5.83333H29.9167V3ZM8.66667 35.5833L8.66667 18.5692L3 18.5833L13.2468 5.83333L24.25 18.5833L18.5833 18.5692L18.5833 22.8333L13.625 29.2083L8.66667 35.5833ZM21.4167 37V32.75H15.75L25.6667 20L35.5833 32.7358H29.9167V37H25.699L21.4167 37ZM22.8333 8.66667H24.25V10.0833H25.6667V11.5H24.25V12.9167H22.8333V11.5H21.4167V10.0833H22.8333V8.66667Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFreeCoins, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/freeCoins.d58c5838.svg";
export { ForwardRef as ReactComponent };